export const ADMIN_PANEL = "admin-panel";
export const MENU = "menu";
